module.exports = __webpack_public_path__ + "static/background-min-073fd2813d68b41212d2244f42db5238.png";